/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { TabsPath } from "~/components/Customer/CustomerNavigation";
import { PremiumSupportCSP } from "~/components/Filters/types";
import { ColumnProps } from "~/components/Tables/types";
import { cloudProvidersList } from "~/constants";
import { ROUTES } from "~/routing";
import { displayCustomerCategory } from "~/tools";
import { displayProvidersIcons } from "~/tools/display/displayProvidersIcons";
import { CustomerRow } from "./CustomersPage";

const StyledRows = styled(FlexContainer)`
  word-break: break-all;
`;

export const CustomersListColumns: ColumnProps<CustomerRow>[] = [
  {
    Header: "Name",
    accessor: "name",
    Cell: ({ row }) => {
      const customerId = row.original.id;

      return (
        <StyledRows>
          {row.original.klarityStatus === "CREATED" ? (
            <Link
              css={{ color: theme.color.text.text01 }}
              to={`${ROUTES.customers.index}/${customerId}/${TabsPath.INFO}`}
              data-cy="customer-name"
            >
              {row.original?.name}
            </Link>
          ) : (
            <span>{row.original?.name}</span>
          )}
        </StyledRows>
      );
    },
  },
  {
    Header: "Providers",
    accessor: "providers",
    disableSortBy: true,
    center: true,
    Cell: ({ row }) => {
      const providers = row.original?.providers;

      const filterProviders = cloudProvidersList.filter(({ value }) =>
        providers.includes(value)
      );

      return (
        <FlexContainer justify="center" css={{ position: "relative" }}>
          {providers.length !== 0 && displayProvidersIcons(filterProviders)}
        </FlexContainer>
      );
    },
  },
  {
    Header: "Categories",
    accessor: "categories",
    disableSortBy: true,
    center: true,
    Cell: ({ row }) => {
      return (
        <FlexContainer justify="center">
          {row.original?.categories.length !== 0 ? (
            row.original?.categories?.map((c) => {
              return (
                <div key={c} css={{ marginRight: "0.5rem" }}>
                  {displayCustomerCategory(c)}
                </div>
              );
            })
          ) : (
            <div css={{ marginRight: "0.5rem" }}>-</div>
          )}
        </FlexContainer>
      );
    },
  },
  {
    Header: "Premium Support CSPs",
    accessor: "premiumSupportCSPs",
    center: true,
    Cell: ({ value }) => {
      return (
        <FlexContainer justify="center">
          {value.length !== 0 && value[0] !== "" ? (
            value?.map((opt: PremiumSupportCSP) => (
              <div key={opt} css={{ marginRight: "0.5rem" }}>
                {opt}
              </div>
            ))
          ) : (
            <div css={{ marginRight: "0.5rem" }}>-</div>
          )}
        </FlexContainer>
      );
    },
  },
];
